import PropTypes from 'prop-types';
import { useState } from 'react';

import { Popover, PopoverTrigger, PopoverContent, Button, Separator } from 'twyne-new.ui'

export default function PopoverConfirmation({ yesAction, title, subtitle, children, trigger, placement }) {
  const [open, setOpen] = useState(false)
  const toggle = () => setOpen(!open)

  const handleYes = () => {
    yesAction()
    setTimeout(() => {
      setOpen(false)
    }, 100)
  }

  const handleNo = () => {
    setOpen(false)
  }

  children = children || <>
    {subtitle && <p className='mb-1'>{subtitle}</p>}
    <Button color="danger" onClick={handleYes} block>Yes, I am sure</Button>
  </>

  return <Popover open={open} onOpenChange={toggle}>
    <PopoverTrigger asChild>
      <div onClick={toggle} className='cursor-pointer'>
        {trigger}
      </div>
    </PopoverTrigger>
    <PopoverContent onPointerDownOutside={toggle} side={placement}>
      {title}
      <Separator className='m-0 my-2' />
      {children}
    </PopoverContent>
  </Popover>
}

PopoverConfirmation.propTypes = {
  id: PropTypes.any,
  yesAction: PropTypes.func,
  target: PropTypes.any,
  subtitle: PropTypes.any,
  title: PropTypes.any,
};
PopoverConfirmation.defaultProps = {
  placement: 'auto',
}
